import React = require("react");
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import "./PredictiveMaintenanceQuestionaire.scss";

declare var AppTranslations: AppTranslations;

const UNKNOWN = "UNKNOWN";

interface PredictiveMaintenanceQuestionNodeProps {
    questionToShow: QuestionJSON;
    canGoBack: boolean;
    editStatus: (status: string) => void;
    resetLastAnswer: () => void;
    questionTranslation: string;
    status: string;
    suggestion: string;
}

interface QuestionJSON {
    code: string;
    description: string;
    priority: number;
    status: string;
}

interface PredictiveMaintenanceQuestionNodeState {
    status: string;
}

// tslint:disable-next-line:max-line-length
export class PredictiveMaintenanceQuestionNode extends React.Component<PredictiveMaintenanceQuestionNodeProps, PredictiveMaintenanceQuestionNodeState> {
    constructor(props: PredictiveMaintenanceQuestionNodeProps) {
        super(props);
        this.state = {status: this.props.status};
    }

    public shouldComponentUpdate(nextProps: Readonly<PredictiveMaintenanceQuestionNodeProps>,
                                 nextState: Readonly<PredictiveMaintenanceQuestionNodeState>,
                                 nextContext: any): boolean {
        return this.props.questionToShow.code !== nextProps.questionToShow.code
            || this.state.status !== nextState.status;
    }

    public render() {
        return (
            // tslint:disable-next-line:no-invalid-template-strings
            <div className="alarmPanelQuestion">
                <div
                    className="alarmPanelQuestionMarginContent alarmPanelQuestionLeftMarginContent"
                    style={{
                        display: this.props.canGoBack ? undefined : "none",
                    }}
                >
                    <div className="verticalAlign"/>
                    {this.backArrowButton()}
                </div>
                <div className="alarmPanelQuestionBodyContent">
                    <div className="alarmPanelQuestionBodyLeft" style={{marginLeft: "5px"}}>
                        <p className="alarmPanelQuestionBodyTitle">
                            {AppTranslations.predictiveTranslation.answer}
                        </p>
                        <p className="alarmPanelQuestionBodyQuestion">
                            {this.props.questionToShow.description}?
                            <br/>
                            <div style={{fontStyle: "italic", fontSize: "12px", marginTop: "4px"}}>
                                {this.props.suggestion} .
                            </div>
                        </p>
                    </div>
                    <div className="alarmPanelQuestionBodyRight">
                        <div className="verticalAlign"/>
                        <ul className="alarm-panel-question-body-answer-list">
                            <li onClick={this.onAnswerClick("YES")}>
                                <input
                                    id="predictiveMaintenanceCheckBoxYES"
                                    type="radio"
                                    className="alarmPanelQuestionAnswerCheckbox"
                                    value="YES"
                                    name="radioWizardGroup-2"
                                    style={{marginRight: "5px"}}
                                    checked={this.props.status != null && this.props.status === "YES"}
                                />
                                <p className="alarmPanelQuestionAnswerText">
                                    {AppTranslations.predictiveTranslation.answerYES}
                                </p>
                            </li>
                            <li onClick={this.onAnswerClick("NO")}>
                                <input
                                    id="predictiveMaintenanceCheckBoxNO"
                                    type="radio"
                                    className="alarmPanelQuestionAnswerCheckbox"
                                    value="NO"
                                    name="radioWizardGroup-2"
                                    style={{marginRight: "5px"}}
                                    checked={this.props.status != null && this.props.status === "NO"}
                                />
                                <p className="alarmPanelQuestionAnswerText">
                                    {AppTranslations.predictiveTranslation.answerNO}
                                </p>
                            </li>
                            <li onClick={this.onAnswerClick("DONT_KNOW")}>
                                <input
                                    id="predictiveMaintenanceCheckBoxDONTKNOW"
                                    type="radio"
                                    className="alarmPanelQuestionAnswerCheckbox"
                                    value="DONT_KNOW"
                                    name="radioWizardGroup-2"
                                    style={{marginRight: "5px"}}
                                    checked={this.props.status != null && this.props.status === "DONT_KNOW"}
                                />
                                <p className="alarmPanelQuestionAnswerText">
                                    {AppTranslations.predictiveTranslation.answerDONTKNOW}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                {this.nextArrowButton()}
            </div>
        );
    }

    private backArrowButton = () => {
        if (!this.props.canGoBack) {
            return null;
        }
        return (
            <div
                className="alarmPanelQuestionMarginNavigationButton alarmPanelQuestionMarginNavigationButtonRotated"
                onClick={this.resetAnswer()}
            />
        );
    }

    private nextArrowButton = () => {
        if (this.props.status !== UNKNOWN) {
            return (
                <div className="alarmPanelQuestionMarginContent alarmPanelQuestionRightMarginContent">
                    <div className="verticalAlign"/>
                    <div
                        className="alarmPanelQuestionMarginNavigationButton"
                        style={{display: "inline-block"}}
                        onClick={this.onAnswerClick(this.props.status)}
                    />
                </div>
            );
        }
        return null;
    }

    private resetAnswer = () => (event: any) => {
        this.props.resetLastAnswer();
    }

    private onAnswerClick = (newStatus: string) => async (event: any) => {
        this.props.editStatus(newStatus);
    }
}
